import { IMinDetails } from '../types/orders';

type ShipmentStatusMasiveResponse = IMinDetails[] | IMinDetails | string | void;
type IMinDetailsWithError = IMinDetails & { error: string };

const isMinDetailsWithError = (item: IMinDetails): item is IMinDetailsWithError => {
  return typeof item.error === 'string';
}

const isSingleErrorResponse = (
  response: IMinDetails | string
): response is IMinDetailsWithError => {
  return (
    typeof response === 'object' &&
    response !== null &&
    'error' in response &&
    typeof response.error === 'string'
  );
}

export const getSerialErrorsFromApiResponse = (
  response: ShipmentStatusMasiveResponse
): IMinDetails[] => {
  if (response == null || typeof response === 'string') {
    return [];
  }

  if (Array.isArray(response)) {
    return response.filter(isMinDetailsWithError).map(item => ({
      saleId: item.saleId ?? '',
      deliveryDate: item.deliveryDate ?? '',
      serial: item.serial ?? '',
      error: item.error
    }));
  }

  if (isSingleErrorResponse(response)) {
    return [
      {
        saleId: response.saleId ?? '',
        deliveryDate: response.deliveryDate ?? '',
        serial: response.serial ?? '',
        error: response.error
      }
    ];
  }

  return [];
};
